import { getDatadogRum, initDatadog } from '@susu/datadog'

import { version } from '../../../package.json'
import { DATADOG_CONFIG } from '../../config'
import { useBookingStore } from '../../store'

export const initDataDog = async (): Promise<(() => void) | undefined> => {
  const { env } = useBookingStore.getState()

  try {
    const { cleanup } = await initDatadog({
      ...DATADOG_CONFIG,
      env,
      version,
    })
    return cleanup
  } catch (error) {
    console.warn('Datadog initialization skipped:', error)
    return undefined
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const datadogLog = async (name: string, data?: any) => {
  const rum = await getDatadogRum()
  if (rum.getInitConfiguration()) {
    rum.addAction(name, data)
  }
}

export const datadogLogPageView = async (name: string) => {
  const rum = await getDatadogRum()
  if (rum.getInitConfiguration()) {
    rum.startView(name)
  }
}
